<template>
    <div class="company-view layout-max-width">
        <heading :title="title" key="company-view-title">
            <b-button
                v-if="canEdit"
                class="mb-2 mb-lg-0"
                variant="primary"
                :to="`/company/edit/${companyId}`">
                Edit Company
                <b-icon-pencil-square/>
            </b-button>
            <b-button
                v-if="canListUsers"
                class="ml-md-4 mb-2 mb-lg-0"
                variant="primary"
                :to="`/user/list/company/${companyId}`">
                Company Users
                <b-icon-people-fill/>
            </b-button>
            <b-button
                class="ml-md-4"
                variant="primary"
                :to="`/equipment/list/${companyId}`">
                Company Equipment
                <b-icon-truck/>
            </b-button>
            <b-button v-if="canDelete"
                      class="ml-md-4"
                      variant="danger"
                      @click="deleteCompany()">
                Delete Company
                <b-icon-trash/>
            </b-button>
        </heading>
        <b-row>
            <b-col class="col-12 col-md-6 offset-md-3 pt-lg-5 text-center">
                <view-table
                    class="company-table"
                    :model="company"
                    :data="companyInfo"
                    :fields="['name', 'ccb_number', 'alt_license_type', 'alt_license_number', 'mailing_address', 'city', 'state', 'zip', 'url', 'status',
                    'cobid_certified', 'cobid_number', 'cobid_types',
                    'companyAdminUser']">
                    <template v-slot:companyAdminUser="slotProps">
                        <user-details :user="slotProps.value"/>
                    </template>
                </view-table>
            </b-col>
        </b-row>

        <company-contact-list class="mt-2"
                              :company-id="companyId"
                              :readOnly="!canEdit"/>

        <attachment-list class="mt-2"
                         model-class="Company"
                         model-table="company"
                         :model-id="companyId"
                         :readOnly="!canEdit"/>
    </div>
</template>

<script>
import Vue from 'vue'
import Company from '@/models/Company'
import AttachmentList from '@/components/AttachmentList'
import Authorization from '@/providers/Authorization'
import UserDetails from '@/components/UserDetails'
import CompanyContactList from '@/components/CompanyContactList'

export default Vue.extend({
    name: 'CompanyView',
    components: { UserDetails, CompanyContactList, AttachmentList },
    props: {
        companyId: Number,
    },
    data () {
        return {
            title: '',
            companyInfo: {},
            company: Company,
            canEdit: false,
            canDelete: false,
            canListUsers: false,
        }
    },
    methods: {
        getStatusLabel (value) {
            return Company.getStatusLabel(value)
        },
        deleteCompany: function (item) {
            if (this.canDelete) {
                this.$bvModal.msgBoxConfirm('Would you like to delete this company? This action cannot be undone.')
                    .then(async (value) => {
                        if (value) {
                            this.$api.deleteItem(this, 'company', this.companyInfo)
                            this.$toasted.info('Company deleted')
                            this.$router.push('/company/list')
                        } else {
                            this.$toasted.error('Unable to delete company')
                        }
                    })
            } else {
                this.$toasted.error(`Unable to delete company`)
            }
        },
    },
    created () {
        this.$api.getItem(this, 'company', this.companyId, ['companyAdminUser'])
            .then((data) => {
                this.title = data['name']
                this.companyInfo = data
                if (this.companyInfo.status) {
                    this.companyInfo.status = Company.getStatusLabel(this.companyInfo.status)
                }
            })
        Authorization.can({ action: 'edit', model: 'company', arg: this.companyId })
            .then((canEdit) => this.canEdit = canEdit)
        Authorization.can({ action: 'delete', model: 'company', arg: this.companyId })
            .then((can) => this.canDelete = can)
        Authorization.can({ action: 'list-users', model: 'company', arg: this.companyId })
            .then((can) => this.canListUsers = can)
    },
})
</script>

<style lang="scss">

.company-table {
    width: 100%;

    th, td {
        font-size: 18px;
    }
}

.company-view {
    .heading__buttons {
        display: flex;
        justify-content: space-between;
        @media (max-width: 767px) {
            flex-wrap: wrap;

            .btn {
                width: 46%;
            }
        }
    }
    .field-value__mailing_address {
        white-space: pre;
    }
}

</style>